import { render } from "./PaymentCancelledPage.vue?vue&type=template&id=204b2102&scoped=true"
const script = {}

import "./PaymentCancelledPage.vue?vue&type=style&index=0&id=204b2102&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204b2102"]])

export default __exports__